var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatientSearch',{attrs:{"callbackSelect":_vm.clickSelect,"collection_name":_vm.collection_name,"mode":1,"showBackBtn":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }